import DeletePromoCodeModalProps from "./DeletePromoCodeModalComponent";

export default DeletePromoCodeModalProps;